import { get } from 'lodash';

export const getEvents = (state) => get(state, 'chargerTelemetry.events.items', []);

export const getChargerSnapshot = (state) => get(state, 'chargerTelemetry.snapshot', {});

export const getChargerMetrics = (state) => get(state, 'chargerTelemetry.metrics', {});

export const getSnapshotLoading = (state) => get(state, 'chargerTelemetry.snapshotLoading', {});

export const getChargerId = (state) => get(state, 'chargerTelemetry.chargerId', {});

export const getDefaultDotsLimitHistorical = (state) =>
  get(state, 'appConfig.config.chargerDetails.telemetry.historical.defaultDotsLimit', 5000);

export const getTelemetryPeriodicityHistorical = (state) =>
  get(state, 'appConfig.config.chargerDetails.telemetry.historical.telemetryPeriodicity', 60);

export const getRealTimeUpdateInterval = (state) =>
  get(state, 'appConfig.config.chargerDetails.telemetry.realtime.minimumUpdatePeriodicity', 60);
